import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { CreditCard, Wallet } from "lucide-react";
// @ts-ignore
import React from "react";

type NormalizedMethod = {
  slug: string;
  isApplicable: boolean;
  applicableAmount: number;
  account: {
    id: any;
    title: string;
    isCash: boolean;
    isDefault: boolean;
    paid_amount: number;
  } | null;
};

export function PaymentMethodCard({
  method,
  selected,
  onSelect,
}: {
  method: NormalizedMethod;
  selected: boolean;
  onSelect: () => void;
}) {
  const { t } = useTranslation();
  // Detect "cash" without external aliases (per UPDATE)
  const isCash = (method.account?.isCash ?? false) || method.slug === "cash";

  // Friendly labels using i18n
  const cashLabel = t("appointment.payment.cash", "Cash");
  const cardLabel = t("appointment.payment.card", "Card");

  const METHOD_LABELS: Record<string, string> = {
    cash: cashLabel,
    card: cardLabel,
    bank_card: cardLabel,
  };

  const label = isCash
    ? cashLabel
    : METHOD_LABELS[method.slug] ?? method.account?.title ?? method.slug;

  return (
    <button
      type="button"
      disabled={!method.isApplicable}
      onClick={onSelect}
      className={cn(
        "w-full rounded-xl border p-4 text-left transition",
        "flex items-center gap-3",
        method.isApplicable ? "cursor-pointer" : "opacity-50 cursor-not-allowed",
        selected ? "border-amber-500 ring-2 ring-amber-200" : "border-border bg-background"
      )}
      aria-pressed={selected}
    >
      <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-muted">
        {isCash ? <Wallet className="h-5 w-5" /> : <CreditCard className="h-5 w-5" />}
      </span>
      <span className="flex min-w-0 flex-col">
        <span className="truncate font-medium">{label}</span>
        {method.account?.title && (
          <span className="truncate text-xs text-muted-foreground">
            {method.account.title}
          </span>
        )}
      </span>
      {selected && (
        <span className="ml-auto inline-flex h-2.5 w-2.5 rounded-full bg-amber-500" />
      )}
    </button>
  );
}
